import { LayoutAllSlots } from '@/data/types/LayoutAllSlots';
import { SLOT_MAP } from '@/data/constants/layout';
import { IncomingContent } from '@/data/types/IncomingContent';
import { getWidgetId } from '@/data/utils/getWidgetId';
import { Widget } from '@/data/types/Slot';
import { getContentNameFromName } from '@/data/utils/getContentNameFromName';
export const getContentItemForSlotByName = (props: IncomingContent, slot: keyof LayoutAllSlots) => {
	const { layout } = props;
	return (
		layout?.slots
			?.find(({ id }) => id === SLOT_MAP[slot])
			?.widgets.map((widget: Widget) => {
				const { name, widgetName } = widget;
				return {
					name:
						widgetName.startsWith('ContentRecommendation_') ||
						widgetName.startsWith('EMarketingSpot_') ||
						widgetName.startsWith('e-marketing-spot-widget')
							? getContentNameFromName(widgetName)
							: getContentNameFromName(name),
					id: getWidgetId(props),
					widgetRaw: { ...widget },
					properties: widget.properties,
				};
			}) || []
	);
};
